export default "__VITE_ASSET__I_hksKD4__"